var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.419 16.3603V8.73829C18.4189 8.28306 18.3153 7.83381 18.1158 7.42458C17.9164 7.01535 17.6265 6.65687 17.268 6.37629L10.942 1.42529C10.5901 1.14973 10.156 1 9.709 1C9.26202 1 8.82793 1.14973 8.476 1.42529L2.15 6.37529C1.79156 6.65607 1.50174 7.01476 1.30249 7.42417C1.10324 7.83358 0.999799 8.28297 1 8.73829V16.3603C1 17.5203 1.94 18.4603 3.1 18.4603H7.07V10.4953H12.348V18.4603H16.318C16.875 18.4603 17.4091 18.239 17.8029 17.8452C18.1967 17.4514 18.419 16.9172 18.419 16.3603Z",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeLight);
export default __webpack_public_path__ + "static/media/home-light.d4295bbbaab60ffb82aa256baed93215.svg";
export { ForwardRef as ReactComponent };